
export interface ConsultationItem {
    contentExecutedInfoIdx: number;
    profileIdx: number;
    counselingIdx: number;
    reservationIdx: number | null; // 상담 취소 시 필요
    endedAt: string | null;
    status: string | null;
    consultantAdminIdx: number | null; // 배정 상담사 idx (이미 신청된 검사의 상담사 식별)
    consultantName: string | null;
    userName: string | null;
    unitVoucherType: string | null;
    dcasResultForm: any | null;
    kpassResultForm: any | null;
    testRound: number;
    desiredDate: string | null;
    desiredTime: string | null;
    reviewWritten: boolean;
    // 검사정보 뱃지용 (백엔드 판정: NS=강점>115 / N=정상 / NW=지원필요<85)
    brainType: "UNKNOWN" | "BALANCED" | "SUCCESSIVE" | "SIMULTANEOUS" | null;
    successiveStatus: "NS" | "N" | "NW" | null;
    simultaneousStatus: "NS" | "N" | "NW" | null;
    planningStatus: "NS" | "N" | "NW" | null;
    attentionStatus: "NS" | "N" | "NW" | null;
}

export interface ConsultationData {
    counselingIdx: number;
    desiredDate: string;
    desiredTime: string;
    preQuestioning: string;
    status?: string;
    review?: string | null;
    reviewCount?: number | null;
    consultantName?: string;
    reservationIdx: number;
}

export interface ConsultationReservationPostDTO{
    desiredDate: string;
}

// 예약 가능 테이블
export interface ConsultationReservation{
    idx: number,
    desiredDate: string,
    desiredTime: string,
    isReserved: boolean,
    counselingIdx: number
}

// 상담 신청 DTO
export interface ConsultationApplyDTO{
    userProfileIdx: number;
    counselingReservationIdx: number;
    contentExecutedInfoIdx: number;
    preQuestioning:string;
    hopeConsultantAdminIdx?: number | null; // 희망 상담사(선택)
}

// 상담 취소 DTO
export interface ConsultationCancelDTO{
    counselingIdx: number;
    userProfileIdx: number;
    counselingReservationIdx: number;
}

// 상담 수정 DTO
export interface ConsultationPutDTO{
    userProfileIdx: number;
    counselingReservationIdx: number;
    preQuestioning: string
}

interface FileDTO{
    idx: number;
    type: any;
    uri: string;
    originalFileName: string;
}

// 배정 상담사 조회
export interface ConsultantInfoDTO{
    idx: number;
    consultantName: string;
    email: string;
    phoneNumber: string;
    briefHistory: string;
    image: FileDTO;
}

// 상담 리뷰 등록
export interface ConsultantReviewPostDTO{
    reviewStar: number;
    review: string;
}

export enum ConsultationModalType{
    EDIT = "EDIT",
    DETAIL = "DETAIL",
    REVIEW = "REVIEW",
    INFO = "INFO",
}